module.exports = __webpack_public_path__ + "img/consumer-top.b6516a56.png";